(() => {
  const sectionSelector = '[data-looom-featured-tea]';
  const tabSelector = '.looom-featured-tea__selector';
  const canUseHover = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  const deactivateTabs = (section) => {
    const tabs = Array.from(section.querySelectorAll(tabSelector));

    tabs.forEach((tab, index) => {
      const panel = section.querySelector(`#${tab.getAttribute('aria-controls')}`);
      const item = tab.closest('.looom-featured-tea__item');

      tab.setAttribute('aria-selected', 'false');
      tab.tabIndex = index === 0 ? 0 : -1;
      if (panel) panel.hidden = true;
      if (item) item.classList.remove('is-active');
    });
  };

  const activateTab = (section, tab, shouldFocus = false) => {
    const tabs = Array.from(section.querySelectorAll(tabSelector));
    if (!tabs.includes(tab)) return;

    tabs.forEach((currentTab) => {
      const isActive = currentTab === tab;
      const panel = section.querySelector(`#${currentTab.getAttribute('aria-controls')}`);
      const item = currentTab.closest('.looom-featured-tea__item');

      currentTab.setAttribute('aria-selected', String(isActive));
      currentTab.tabIndex = isActive ? 0 : -1;

      if (panel) panel.hidden = !isActive;
      if (item) item.classList.toggle('is-active', isActive);
    });

    if (shouldFocus) tab.focus();
  };

  const initialiseSection = (section) => {
    if (!section || section.dataset.looomFeaturedTeaInitialised === 'true') return;

    section.dataset.looomFeaturedTeaInitialised = 'true';
    const mobileBreakpoint = window.matchMedia('(max-width: 767px)');

    const syncMobilePanels = () => {
      const tabs = Array.from(section.querySelectorAll(tabSelector));
      const grid = section.querySelector('.looom-featured-tea__grid');

      if (mobileBreakpoint.matches) {
        if (grid) grid.removeAttribute('role');

        tabs.forEach((tab) => {
          const panelId = tab.getAttribute('aria-controls');
          const panel = section.querySelector(`#${panelId}`);

          if (panelId) tab.dataset.looomFeaturedTeaPanelId = panelId;
          tab.removeAttribute('role');
          tab.removeAttribute('aria-selected');
          tab.removeAttribute('aria-controls');
          tab.tabIndex = 0;

          if (panel) {
            panel.hidden = false;
            panel.setAttribute('role', 'region');
          }
        });
      } else {
        if (grid) grid.setAttribute('role', 'tablist');

        tabs.forEach((tab) => {
          const panelId = tab.dataset.looomFeaturedTeaPanelId || tab.getAttribute('aria-controls');
          const panel = section.querySelector(`#${panelId}`);

          tab.setAttribute('role', 'tab');
          tab.setAttribute('aria-selected', 'false');
          tab.setAttribute('aria-controls', panelId);
          if (panel) panel.setAttribute('role', 'tabpanel');
        });

        deactivateTabs(section);
      }
    };

    section.addEventListener('click', (event) => {
      const variantButton = event.target.closest('.looom-featured-tea__variant-link');
      if (variantButton && section.contains(variantButton)) {
        const variantForm = variantButton.closest('.looom-featured-tea__variants');
        variantForm?.querySelectorAll('.looom-featured-tea__variant-link').forEach((button) => {
          const isSelected = button === variantButton;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-pressed', String(isSelected));
        });
      }

      if (mobileBreakpoint.matches) return;

      const tab = event.target.closest(tabSelector);
      if (tab && section.contains(tab)) activateTab(section, tab);
    });

    section.addEventListener('pointerover', (event) => {
      if (!canUseHover()) return;

      const item = event.target.closest('.looom-featured-tea__item');
      const tab = item?.querySelector(tabSelector);
      if (!item || !tab || !section.contains(item) || item.contains(event.relatedTarget)) return;

      activateTab(section, tab);
    });

    section.addEventListener('pointerout', (event) => {
      if (!canUseHover()) return;

      const item = event.target.closest('.looom-featured-tea__item');
      if (!item || !section.contains(item) || item.contains(event.relatedTarget)) return;

      deactivateTabs(section);
    });

    section.addEventListener('keydown', (event) => {
      if (mobileBreakpoint.matches) return;

      const tab = event.target.closest(tabSelector);
      if (!tab || !section.contains(tab)) return;

      const tabs = Array.from(section.querySelectorAll(tabSelector));
      const currentIndex = tabs.indexOf(tab);
      let nextIndex = null;

      if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % tabs.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = tabs.length - 1;

      if (nextIndex !== null) {
        event.preventDefault();
        activateTab(section, tabs[nextIndex], true);
      }

      if (event.key === ' ' && tab.tagName !== 'A') {
        event.preventDefault();
        activateTab(section, tab);
      }
    });

    syncMobilePanels();
    mobileBreakpoint.addEventListener('change', syncMobilePanels);
  };

  const initialiseAll = (scope = document) => {
    if (scope.matches && scope.matches(sectionSelector)) initialiseSection(scope);
    scope.querySelectorAll(sectionSelector).forEach(initialiseSection);
  };

  const start = () => {
    initialiseAll();

    if (document.documentElement.dataset.looomFeaturedTeaEditorListener === 'true') return;

    document.documentElement.dataset.looomFeaturedTeaEditorListener = 'true';
    document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
